export enum LoginType {
  GOV = 'gov',
  CONCESSIONARIA = 'concessionaria',
}
